export default __webpack_public_path__ + "static/media/DSC_0556.1f754266.jpg";